<template>
  <div class="more-wrapper">
    <div class="module-title" />
    <div class="more-info">
      <div class="more-bd-qr"><img :src="moreInfo.bdQR" alt="" /></div>
      <div class="more-main">
        <div class="more-bada"><img :src="moreInfo.bd" alt="" /></div>
        <div class="more-manhua"><img :src="moreInfo.mh" alt="" /></div>
      </div>
      <div class="more-mh-qr"><img :src="moreInfo.mhQR" alt="" /></div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {}
  },
  props: {
    moreInfo: {
      type: Object,
      default: () => {},
    },
  },
  methods: {},
}
</script>
<style lang="less">
.more-wrapper {
  position: relative;
  width: 110.1rem;
  margin: 0 auto 12.6rem;
  .module-title {
    background-image: url('../images/title-gd.png');
  }
  .more-info {
    display: flex;
    margin-top: 4rem;
  }
  .more-main {
    width: 63rem;
    margin-left: 1.4rem;
    margin-right: 2.1rem;
  }
  .more-bada,
  .more-manhua,
  .more-bd-qr,
  .more-mh-qr {
    background-repeat: no-repeat;
    background-size: contain;
    img {
      width: 100%;
    }
  }
  .more-bada,
  .more-manhua {
    width: 51.9rem;
    height: 12.4rem;
  }
  .more-bd-qr,
  .more-mh-qr {
    width: 21.8rem;
    height: 27rem;
    font-size: 2。7rem;
    text-align: center;
    color: #ffffff;
  }
  .more-bada {
    margin-bottom: 2.2rem;
  }
  .more-manhua {
    position: relative;
    left: 11.5rem;
  }
}
</style>
